/**
 * ReadOnlyWidgetGrid — a dashboard's widgets as a responsive grid of `WidgetCard`s with no edit controls: the saved
 * view the simplified shell opens.
 */
import type React from 'react';
import type { DashboardWidget } from '../../generated/api/types.gen.js';
import { WidgetCard } from './WidgetCard.js';

const noop = () => {};

export const ReadOnlyWidgetGrid: React.FC<{ widgets: DashboardWidget[] }> = ({ widgets }) => (
  <div className="grid gap-3.5 grid-cols-[repeat(auto-fit,minmax(240px,1fr))]">
    {widgets.map((widget, index) => (
      <WidgetCard
        key={widget.id}
        widget={widget}
        editMode={false}
        isFirst={index === 0}
        isLast={index === widgets.length - 1}
        onMoveUp={noop}
        onMoveDown={noop}
        onRemove={noop}
      />
    ))}
  </div>
);
